// extracted by mini-css-extract-plugin
export var icon = "_bw-3";
export var subtitle = "_bw-2";
export var title = "_bw-1";
export var value = "_bw-0";